import type { Ref } from 'react';
import { useRef, useState, useEffect, forwardRef, useImperativeHandle } from 'react';
import { detectIfTruncated } from '../../common-functions';
import Input from '../../fields/input/input.component';
import Tooltip from '../../tooltip-component/tooltip.component';
import type { DataGridDataCellBaseProps } from '../data-grid-settings.interface';

export type DataGridDataNumericalCellProps = DataGridDataCellBaseProps<string | number | bigint> & {
  isEditing?: boolean;
  width?: number;
};

function DataGridDataNumericalCell(
  { value, isEditing = false, width }: DataGridDataNumericalCellProps,
  forwardRef: Ref<HTMLDivElement>
) {
  const cellValue = value?.toString();
  const cellRef = useRef<HTMLDivElement>(null);
  const [isTruncated, setIsTruncated] = useState(false);

  useImperativeHandle(forwardRef, () => cellRef.current as HTMLDivElement);

  useEffect(() => {
    if (cellRef.current) {
      setIsTruncated(detectIfTruncated(cellRef.current));
    }
  }, [width]);

  return isEditing ? (
    <Input type="number" name={cellValue} value={cellValue} />
  ) : (
    <Tooltip
      description={cellValue}
      tooltipClassName="odin-bg-mono-1"
      disabled={!isTruncated}
      tooltipZIndexCheck={true}
    >
      {/*  NOTE: if modifying the padding 'odin-pl-2', please remember to update all other cells as well as 'CELL_PADDING_LEFT_PX' */}
      <div className="odin-truncate odin-pl-2" data-testid="data-grid-cell-content" ref={cellRef}>
        {cellValue}
      </div>
    </Tooltip>
  );
}

export default forwardRef(DataGridDataNumericalCell);
